/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "input_"
};
import { watch, watchEffect } from 'vue';
import _ from 'lodash';
export default {
  __name: 'inputSend',
  props: ['remark_text'],
  emits: ['onSend'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var send_text = ref('');
    var props = __props;
    var emit = __emit;
    var send = () => {
      var value_ = send_text.value;
      emit('onSend', value_);
      send_text.value = '';
    };
    watch(() => {
      return props.remark_text;
    }, () => {
      send_text.value = props.remark_text;
    });
    return (_ctx, _cache) => {
      var _component_el_button = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(send_text) ? send_text.value = $event : null),
        name: "",
        id: "",
        cols: "30",
        rows: "10",
        placeholder: "发表评论"
      }, null, 512), [[_vModelText, _unref(send_text)]]), _createVNode(_component_el_button, {
        class: "send",
        type: "primary",
        color: "#248f83",
        onClick: send
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("发送")])),
        _: 1
      })]);
    };
  }
};